export const isArray = (v: unknown): v is unknown[] => Array.isArray(v);
